import * as React from "react";

import {Icon, SemanticICONS, Step} from "semantic-ui-react";

export enum EStepTab {
    OverviewTab,
    ConfirmTab,
    ResultTab
}

export type StepTab = {
    step: EStepTab;
    icon: SemanticICONS;
    title: string;
};

export const stepTabList: StepTab[] = [
    {
        step: EStepTab.OverviewTab,
        icon: 'list',
        title: 'PSL_MULTI_DLT:OVERVIEW_TAB'
    },
    {
        step: EStepTab.ConfirmTab,
        icon: 'checkmark',
        title: 'PSL_MULTI_DLT:CONFIRM_TAB'
    },
    {
        step: EStepTab.ResultTab,
        icon: 'info',
        title: 'PSL_MULTI_DLT:RESULT_TAB'
    }
];

export interface StepHeaderProps {
    activeTab: EStepTab;
    t: reactI18Next.TranslationFunction;
}

export const StepHeader = (props: StepHeaderProps) => (
    <Step.Group size={'mini'} className={'width--100Percent'}>
        {stepTabList.map((item) =>
            <Step key={item.step} active={props.activeTab === item.step}>
                <Icon name={item.icon} />
                <Step.Content>
                    <Step.Title>{props.t(item.title)}</Step.Title>
                </Step.Content>
            </Step>
        )}
    </Step.Group>
);



// WEBPACK FOOTER //
// ./src/views/OptionsView/multipleOptionDeletionDialog/MODUtils.tsx